module.exports = __webpack_public_path__ + "img/mugshot.d4d927c5.png";